import { checkIsErrorToolOutput } from "@repo/app-types/agents/errorToolOutput";
import type { GetKnowledgeDocumentToolOutput } from "@repo/app-types/entities/copilot";
import type { KnowledgeRetrievalToolInput } from "@repo/app-types/entities/knowledgeRetrievalTool";
import { ChatToolBase, type ToolComponent } from "@repo/ui/chat/chatToolCall";

export const GetKnowledgeDocumentTool: ToolComponent<
  KnowledgeRetrievalToolInput,
  GetKnowledgeDocumentToolOutput
> = (props) => {
  const renderText = () => {
    if (props.status.type !== "complete" || !props.output) {
      return `Retrieving knowledge base document...`;
    }

    if (checkIsErrorToolOutput(props.output)) {
      return "An error occurred while retrieving the knowledge base document";
    }

    if (!props.output.document) {
      return "The knowledge base document was not found";
    }

    return `Retrieved "${props.output.document.title}"`;
  };

  return <ChatToolBase status={props.status}>{renderText()}</ChatToolBase>;
};
